import React, { Component } from 'react'

export default class OutClick extends Component {
  constructor(props) {
    super(props)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.props.handleClick(e)
    }
  }

  render() {
    return <div className={this.props.className ? this.props.className : ""}
                onClick={e => e.stopPropagation()}
                style={this.props.style ? this.props.style : {}}
                ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/out_click.js